import { Scale } from "lucide-react";
import { Reveal } from "../components/Chapter";
import { LEGAL_PAGES } from "../lib/data";

export default function LegalPage({ pageKey }) {
  const page = LEGAL_PAGES[pageKey];
  if (!page) return null;

  return (
    <main className="grain" data-testid={`page-${pageKey}`}>
      <section className="relative pt-40 pb-24 px-6 sm:px-10 lg:px-16 bg-sand overflow-hidden">
        <Scale className="absolute -right-8 top-24 w-56 h-56 text-pine/5 -rotate-12" />
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <span className="font-body text-xs font-bold tracking-[0.25em] uppercase text-terra">
              Informations légales
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-5 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1] tracking-tight text-ink">
              {page.title}
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-ink/60 leading-relaxed">{page.intro}</p>
          </Reveal>

          <div className="mt-14 space-y-10">
            {page.sections.map((s, i) => (
              <Reveal key={s.h} delay={0.05 * i}>
                <section data-testid={`legal-section-${i}`}>
                  <h2 className="font-display font-bold text-2xl text-pine flex items-baseline gap-3">
                    <span className="text-sm font-body font-bold text-terra tracking-[0.2em]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {s.h}
                  </h2>
                  <div className="mt-4 space-y-3">
                    {s.paragraphs.map((p, j) => (
                      <p key={j} className="text-ink/65 leading-relaxed">
                        {p}
                      </p>
                    ))}
                  </div>
                </section>
              </Reveal>
            ))}
          </div>

          <p className="mt-16 font-hand text-2xl text-terra -rotate-1">
            dernière mise à jour : septembre 2026
          </p>
        </div>
      </section>
    </main>
  );
}
